import { Field, Formik } from 'formik';
import { Form, Modal } from 'react-bootstrap';
import { TEXTAREA_ROW_LENGTH } from '../../../../constants/constants';
import validAllowedCharacters from '../../../../constants/valid-character-password';
import validCharacters from '../../../../constants/valid-characters';
import { IBaseFactory } from '../../../../models/forms/IAddUpdateFactory';
import FormikFormInput from '../../../../shared-components/FormikFormHandlers/FormikFormInput';
import FormikFormTextArea from '../../../../shared-components/FormikFormHandlers/FormikFormTextArea';
import { FactoryDetailsValidationSchema } from '../../../../shared-components/FormikFormHandlers/FormikValidationSchema';
import FormLoader from '../../../../shared-components/FormLoader/FormLoader';
import Label from '../../../../shared-components/label/label';
import ModalFooter from '../../../../shared-components/modal/modal-footer';
import { formatMessage } from '../../../../translations/format-message';

interface IProps {
  id: number;
  initalValues: IBaseFactory;
  isLoading: boolean;
  next: (newData: any, final?: boolean) => void;
  onModalClosed: () => void;
}

export const StepFactoryDetails = (props: IProps) => {
  const handleNextStep = (values: IBaseFactory) => {
    props.next(values);
  };

  return (
    <Formik
      initialValues={props.initalValues}
      onSubmit={handleNextStep}
      validationSchema={FactoryDetailsValidationSchema}
      validateOnBlur={false}
      enableReinitialize
    >
      {({ handleSubmit, handleBlur, handleChange }) => (
        <Form
          id="formBody"
          onSubmit={handleSubmit}
        >
          {props.isLoading && <FormLoader loading={props.isLoading} />}

          <Modal.Body className="overflow-hidden">
            <div className="wizard">
              <div className="wizard-inner">
                <div className="connecting-line"></div>
                <ul
                  className="nav nav-tabs"
                  role="tablist"
                >
                  <li
                    role="presentation"
                    className="active"
                  >
                    <a
                      // href="#step1"
                      data-toggle="tab"
                      aria-controls="step1"
                      role="tab"
                      aria-expanded="true"
                    >
                      <span className="round-tab">1 </span>{' '}
                      <i>{formatMessage('factory_deails')}</i>
                    </a>
                  </li>
                  <li
                    role="presentation"
                    className="disabled"
                  >
                    <a
                      // href="#step2"
                      data-toggle="tab"
                      aria-controls="step2"
                      role="tab"
                      aria-expanded="false"
                    >
                      <span className="round-tab">2</span>{' '}
                      <i>{formatMessage('user_details')}</i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4 col-12">
                <div className="form-group formSet">
                  <Label
                    className="label-style"
                    required={true}
                    label="factory_name"
                  />
                  <Field
                    data-testid="FactoryName"
                    className="form-control"
                    name="FactoryName"
                    placeholder=""
                    type="text"
                    validcharacter={validCharacters}
                    as={FormikFormInput}
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="col-md-4 col-12">
                <div className="form-group formSet">
                  <Label
                    className="label-style"
                    required={true}
                    label="factory_city"
                  />
                  <Field
                    data-testid="FactoryCity"
                    className="form-control"
                    name="FactoryCity"
                    placeholder=""
                    type="text"
                    as={FormikFormInput}
                    validcharacter={validAllowedCharacters}
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="col-md-4 col-12">
                <div className="form-group formSet">
                  <Label
                    className="label-style"
                    label="factory_country"
                  />
                  <Field
                    data-testid="FactoryCountry"
                    className="form-control"
                    name="FactoryCountry"
                    disabled={true}
                    placeholder=""
                    type="text"
                    validcharacter={['@', '#', '$', '-', '_', '.']}
                    as={FormikFormInput}
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="col-12">
                <div className="form-group formSet">
                  <Label
                    className="label-style"
                    required={false}
                    label="location"
                  />
                  <Field
                    rows={TEXTAREA_ROW_LENGTH}
                    id="FactoryAddress"
                    className="form-control"
                    name="FactoryAddress"
                    placeholder=""
                    type="text"
                    as={FormikFormTextArea}
                  />
                </div>
              </div>
            </div>
          </Modal.Body>

          <ModalFooter
            id={props.id}
            onModalClosed={props.onModalClosed}
            isLoading={props.isLoading}
            saveNextBtn="next"
            backCancelBtn="cancel"
          />
        </Form>
      )}
    </Formik>
  );
};
